import fallback from '../../img/cu.jpg';

/**
 * General helper functions for Carelton Univeristy
 * Authors: Michael Ieradi
 **/

/**
 * Errors
 * @mieradi
 */

export const isError = function () {
	const err = new Error('There seems to be an issue loading this content');
	return `<div class="u-block u-block__error"><h2>${err}</h2></div>`;
};
/**
 * ToggleClassesInList
 * Target a classlist of multiple items, and add classes on an event of your choice
 * Note: if this is a NodeList, create array with Array.from()
 * @mieradi
 */

export const toggleClassesInList = (elements, eventType, classToToggle) => {
	// check if elements exist
	if (elements && elements !== 'undefined') {
		// add event listener to each single element
		elements.forEach(singleElement => {
			singleElement.addEventListener(eventType, () => {
				//remove class if it exists
				elements.forEach(singleElement => {
					if (singleElement.classList.contains(classToToggle)) {
						singleElement.classList.remove(classToToggle);
					}
				});

				//add class
				singleElement.classList.add(classToToggle);
			});
		});
	}
};

/**
 *  Check is element is in viewport
 *  @mieradi
 */
export const isInViewport = function (elem) {
	// get the elements bounds
	let bounding = elem.getBoundingClientRect();

	// check bounds against viewport
	return (
		bounding.top >= 0 &&
		bounding.left >= 0 &&
		bounding.bottom <=
		(window.innerHeight || document.documentElement.clientHeight) &&
		bounding.right <=
		(window.innerWidth || document.documentElement.clientWidth)
	);
};

/**
 * Lazy load Images on scroll
 * in use:
 * 1 - element choice runs querySelectorAll under the hood. CU uses '.js-lazyload' on img assets
 * 2 - add a data attribute of 'imgsrc' to the img element
 * 3 - remove the img src, and put it in the data attribute. leave the img src empty.
 * 4 - isInViewport will check the location of the elemebt, and if in viewport, the img src will be populated with the data attribute contents.
 * eg:  <img class="js-lazyload" src="" data-imgsrc="yourimagesourcegoeshere" />
 *
 *	@mieradi
 */
export const lazyLoader = () => {
	//query all elements with the class .js-lazyload
	let images = document.querySelectorAll('.js-lazyload');

	//set a scrolltimeout variable
	let scrollTimeout;

	//create array from NodeList
	images = Array.from(images);

	//clear timeout
	if (scrollTimeout) {
		clearTimeout(scrollTimeout);
	}
	images.forEach(img => {
		if (img.src == fallback || img.src == img.dataset.imgsrc) {
			return;
		} else if (isInViewport(img)) {
			// populate src with imgsrc
			img.src = img.dataset.imgsrc;
		}
	});
	// delay scroll functions for optiomizations
	scrollTimeout = setTimeout(() => {
		images.forEach(img => {
			if (img.src == fallback || img.src == img.dataset.imgsrc) {
				return;
			}

			img.addEventListener('error', () => {
				img.src = fallback;
			});
			if (
				img.src !== typeof 'string' &&
				isInViewport(img) &&
				!img.src == img.dataset.imgsrc
			) {
				// populate src with imgsrc
				img.src = img.dataset.imgsrc;
			}
		});
		if (images.length == 0) {
			// if no images, remove listeners
			document.removeEventListener('scroll', lazyLoader);
			window.removeEventListener('resize', lazyLoader);
			window.removeEventListener('orientationChange', lazyLoader);
		}
		document.addEventListener('scroll', lazyLoader);
		window.addEventListener('resize', lazyLoader);
		window.addEventListener('orientationChange', lazyLoader);
	});
};
